<h1>{{ 'content.mfa' | translate }}</h1>

@if (showIncorrectCode) {
  <div class="error-box p-2 mb-2">{{ 'content.mfa-incorrect-code' | translate }}</div>
}

@if (!initialRequestSent) {
  <div>{{ 'content.please-wait' | translate }}</div>
}

@if (showAppDetails) {
  <div class="d-flex flex-column">
    <fa-icon [icon]="mfaService.getTypeIcon(lastUsedDevice)" [attr.aria-label]="mfaService.getDescriptionI18nKey(lastUsedDevice) | translate"></fa-icon>
    <div>{{ 'content.accept-request-from-ping-app-on-device' | translate:{displayId: mfaAuthenticationDisplayId} }}</div>
  </div>
}

@if (showAppFailure) {
  <div class="d-flex flex-column">
    <div>{{ 'content.authenticating-with-app-timed-out-or-denied' | translate }}</div>
    <ng-container *ngTemplateOutlet='optionButtons; context:{showResend: true, showOtherWays: true, showSubmit: false, otherWaysCallback: "appFailure"}'></ng-container>
  </div>
}

@if (showOtpForm) {
  <div>
    <form [formGroup]="formGroup"
      [ngClass]="{'form-submitted': formSubmitted}"
      (submit)="submitMfaCode(formGroup.value)">
      @if (!!mfaAuthenticationDisplayId) {
        <div>
          {{ 'content.enter-the-code-sent-through' | translate:{method: mfaAuthenticationDisplayId} }}
        </div>
      }
      <div class="form-group pt-2">
        <label>{{ 'content.code' | translate }}
          <input class="form-control" type="text" autocomplete="off" formControlName="code" #codeInput>
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [errors]="formGroup.controls.code.errors" [element]="codeInput"></app-validation-errors>
      </div>
      <ng-container *ngTemplateOutlet='optionButtons; context:{showResend: true, showOtherWays: true, showSubmit: true, otherWaysCallback: "otp"}'></ng-container>
    </form>
  </div>
}

@if (showOtherWays) {
  <div aria-label="Choose a device" role="region">
    <h2 class="no-underline">{{ 'content.choose-a-device' | translate }}</h2>
    <div>{{ 'content.choose-device-to-authenticate-with' | translate }}</div>
    <div class="d-flex flex-column m-2">
      @for (device of jwtToken?.mfaUserDetails?.devicesDetails || []; track device) {
        <div class="ng-bootstrap-card d-block m-2">
          <fa-icon [icon]="mfaService.getTypeIcon(device)"></fa-icon>
          <div>{{ 'content.type' | translate }}: {{ device?.type }}</div>
          <div>{{ mfaService.toLabel(device) }}</div>
          @if (device?.deviceRole === 'SECONDARY' && (device?.type === 'Android' || device?.type === 'iPhone')) {
            <div class="mt-2">
              {{ 'content.mfa-app-as-secondary-warning' | translate }}
            </div>
          }
          <div class="d-flex justify-content-end">
            <button class="tu-button primary tu-shadow mt-1" (click)="authenticateWith(device)">{{ 'content.use-this-device' | translate }}</button>
          </div>
        </div>
      }
    </div>
    <h2>{{ 'content.having-trouble' | translate }}</h2>
    <div>{{ 'content.please-contact-your-administrator-or-support' | translate }}</div>
    <div class="mt-2 d-flex justify-content-end align-items-center submit-buttons">
      <button class="tu-button secondary tu-shadow" type="button" (click)="showOtpForm = true">{{ 'content.cancel' | translate }}</button>
    </div>
  </div>
}

<ng-template #optionButtons let-showSubmit='showSubmit' let-otherWaysCallback='otherWaysCallback'>
  <div class="mt-2 d-flex justify-content-between align-items-center submit-buttons">
    <div class="d-flex flex-column align-items-start">
      <button class="tu-link" type="button" (click)="resendCode()">{{ 'content.resend-code' | translate }}</button>
      <button class="tu-link" type="button" (click)="chooseOtherDevice(otherWaysCallback)">{{ 'content.try-a-different-way' | translate }}</button>
    </div>
    <div class="d-flex align-items-end inline-gap-5">
      <button class="tu-button secondary tu-shadow" type="button" (click)="logout()">{{ 'content.cancel' | translate }}</button>
      @if (showSubmit) {
        <button class="tu-button primary tu-shadow" type="submit">{{ 'content.submit' | translate }}</button>
      }
    </div>
  </div>
</ng-template>
